import {Message, Loading, MessageBox} from 'element-ui'
import store from '../store'
import service from '@/utils/service'
/**
 * @Description:  页面相关方法
 * @param:
 * @Author: ZhangBin
 * @Date 2019-08-13 13:51
 */
export default {
  install(Vue, options) {

    /**********用户权限相关**********/
    /**
     * @Description:  判断用户可用功能
     * @param:
     * @Author: ZhangBin
     * @Date 2019-05-17 17:13
     */
    Vue.prototype.judgeUserFunction = (path) => {
      // 用户可用功能

      let userFunction = JSON.parse(store.getters.userFunction);
      if(!userFunction) {
        Message({
          message: '此用户暂无此权限',
          type: 'warning',
          duration: 2000
        });
        return false;
      }
      let permission = userFunction.includes(path);
      if(!permission) {
        Message({
          message: '此用户暂无此权限',
          type: 'warning',
          duration: 2000
        });
      }
      return permission;
    };
    /********** END **********/

    /********** 大屏 **********/
    /**
     * @Description:  pm2.5格式化
     * @param:
     * @Author: ZhangBin
     * @Date 2019-08-14 11:18
     */
    Vue.prototype.pm25Standard = (val) => {
      if(val > 0 && val <= 35) {
        return '优'
      } else if(val > 35 && val <= 75) {
        return '良'
      } else if(val > 75 && val <= 115) {
        return '轻度污染'
      } else if(val > 115 && val <= 150) {
        return '中度污染'
      } else if(val > 150 && val <= 250) {
        return '重度污染'
      } else if(val > 250) {
        return '严重污染'
      } else {
        return '';
      }
    };
    /********** END **********/
    /**
     * @Description:  格式化请求参数 date 为 startTime endTime
     * @param: params Object
     * @Author: ZhangBin
     * @Date 2019-12-17 13:37
     */
    Vue.prototype.formatReqDateParams = (params) => {
      let _this = new Vue();
      if(Object.prototype.toString.call(params) === '[object Object]') {
        let obj = Object.assign({}, params); // 不修改源对象
        if(_this.hasOwn(obj, 'date')) {
          if(_this.isAbsoluteTrue(obj.date) && !_this.isEmptyObject(obj.date)) {
            Reflect.set(obj, 'startTime', obj.date[0]);
            Reflect.set(obj, 'endTime', obj.date[1])
          } else {
            Reflect.set(obj, 'startTime', '');
            Reflect.set(obj, 'endTime', '')
          }
          Reflect.deleteProperty(obj, 'date');
          return obj
        } else {
          return obj
        }
      }
      else {
        throw new Error('The argument `params` must be an object!')
      }
    };
    /********** END **********/
  },


}



// WEBPACK FOOTER //
// ./src/utils/pageUtils.js